import React from "react";
import "./styles/BirthdayTitle.css";

const BirthdayTitle = () => (
  <div className="candle-count-display">
    HAPPY BIRTHDAY <br/> MS. THREXY OBENARIO!!
  </div>
);

export default BirthdayTitle;
